// extracted by mini-css-extract-plugin
module.exports = {"search__header":"SearchHeader_search__header__FS3eg"};